export default {
  actions: 'Actions',
  active: 'Active',
  add: 'Add',
  after: 'After',
  all: 'All',
  attack: 'Experiment',
  authentication: 'Authentication'
}
